/**
 * DOM Elements
 */
export const elements = {
  body: document.body,
  bodyWrap: document.querySelector('.body-wrapper'),
  aboutWrap: document.querySelector('.about-wrapper'),
  worksContainer: document.querySelector('.moreWorks-container'),
  homeHeaderEl: document.querySelector('.header--home'),
  homeHeaderText: document.querySelector('.header--home div'),
  subNavigation: document.querySelector('.sub-nav'),
  animationElements: document.querySelectorAll('.js--animation-element'),
  secondaryHeadings: document.querySelectorAll('.heading-secondary'),
  sectionNums: document.querySelectorAll('.section-title__number'),
  highlightEl: document.querySelectorAll('.highlight'),
  //Navigation
  navLogo: document.querySelector('.navbar-logo'),
  navWrap: document.querySelector('.navigation'),
  navCheckbox: document.querySelector('.navigation__checkbox'),
  navButton: document.querySelector('.navigation__button'),
  navBackground: document.querySelector('.navigation__background'),
  navBar: document.querySelector('.navigation__nav'),
  navList: document.querySelector('.navigation__list'),
  navItems: document.querySelectorAll('.navigation__item'),
};

/**
 * Media Queries
 */
export const mqList = {
  small: window.matchMedia('(max-width: 37.5em)'),
  medium: window.matchMedia('(max-width: 50em)'),
  medLarge: window.matchMedia('(max-width: 60em)'),
  xlarge: window.matchMedia('(max-width: 75em)'),
};

/**
 * Loader
 */
export function renderLoader(parent) {
  const loader = `
  <div class="loader">
    <img src="assets/images/loader.svg" alt="loader icon" class="loader__icon">
  </div>
  `;

  parent.insertAdjacentHTML('afterbegin', loader);
}

export function clearLoader() {
  const loader = document.querySelector('.loader');

  if (loader) loader.parentElement.removeChild(loader);
}

/**
 * Check if the top of the element is visible (https://javascript.info/onscroll)
 */
export function isVisible(element) {
  const coords = element.getBoundingClientRect();
  const windowHeight = document.documentElement.clientHeight;

  const topVisible = coords.top > 0 && coords.top < windowHeight * 0.75;
  const bottomVisible = coords.bottom > 0 && coords.bottom < windowHeight;

  return topVisible || bottomVisible;
}

/**
 * Check if the navigation is visible
 */
export function isNavVisible() {
  const { scrollY } = window;
  const { bodyWrap, navLogo, aboutWrap } = elements;
  let distance;

  if (bodyWrap) {
    distance = bodyWrap.offsetTop - navLogo.offsetTop;
  } else if (aboutWrap) {
    distance = navLogo.offsetTop;
    // distance = aboutWrap.offsetTop - navLogo.offsetTop;
  }

  return distance - scrollY > 0 ? true : false;
}

/**
 * iframe lazy loading (https://web.dev/iframe-lazy-loading/)
 */
export function lazyLoad() {
  if ('loading' in HTMLIFrameElement.prototype) {
    const iframes = document.querySelectorAll('iframe[loading="lazy"]');

    iframes.forEach((iframe) => {
      iframe.src = iframe.dataset.src;
    });
  } else {
    // Dynamically import the LazySizes library
    const script = document.createElement('script');
    script.src =
      'https://cdnjs.cloudflare.com/ajax/libs/lazysizes/5.3.2/lazysizes.min.js';
    document.body.appendChild(script);
  }
}
